var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#282828",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55021 7.06424C3.58783 6.61273 3.60665 6.38697 3.69657 6.21123C3.80522 5.99891 3.98617 5.8324 4.20679 5.74177C4.38939 5.66675 4.61593 5.66675 5.069 5.66675H10.931C11.3841 5.66675 11.6106 5.66675 11.7932 5.74177C12.0138 5.8324 12.1948 5.99891 12.3034 6.21123C12.3934 6.38697 12.4122 6.61273 12.4498 7.06424L12.5848 8.68402C12.6347 9.28293 12.6596 9.58239 12.6494 9.83087C12.5692 11.7845 11.0884 13.3938 9.14826 13.6359C8.90149 13.6667 8.60099 13.6667 8 13.6667V13.6667C7.39901 13.6667 7.09851 13.6667 6.85174 13.6359C4.91156 13.3938 3.43079 11.7845 3.35057 9.83087C3.34036 9.58239 3.36532 9.28293 3.41523 8.68402L3.55021 7.06424Z",
    stroke: "current-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 4.66675L5.66797 4.33341C5.66797 3.04475 6.71264 2.00008 8.0013 2.00008V2.00008C9.28997 2.00008 10.3346 3.04475 10.3346 4.33341L10.3346 4.66675",
    stroke: "current-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66797 8.33325V7.33325",
    stroke: "current-color",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 8.33325V7.33325",
    stroke: "current-color",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/Jobs.f05d1b537c2dd5341a2b564e02a097b1.svg";
export { ForwardRef as ReactComponent };